import { ReactNode } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { App, ConfigProvider, Spin } from "antd";
import ruRU from "antd/locale/ru_RU";
import { theme } from "@shared/ui";

type AntdConfigAppProviderProps = {
  children: ReactNode;
};

export function AntdGlobalProvider({ children }: AntdConfigAppProviderProps) {
  Spin.setDefaultIndicator(
    <LoadingOutlined spin style={{ color: "#0034AD" }} />,
  );
  return (
    <ConfigProvider {...theme} locale={ruRU}>
      <App>{children}</App>
    </ConfigProvider>
  );
}
